<!-- src/components/PaymentDetailTab.vue -->
<template>
  <div>
    <div class="search-box">
      <div class="left">
        <div class="child">
          <DateSelect ref="dateSelect" @change="dateChange">支付日期：</DateSelect>
        </div>
        <div class="child">
          <span class="label">单据号：</span>
          <el-input
            v-model="searchParams.billNo"
            placeholder="请输入支付单号、来源单号"
            style="width:180px"
            size="mini"
            clearable
          />
        </div>
        <div class="child">
          <span class="label">来源类型：</span>
          <el-select
            v-model="searchParams.sourceBillTypes"
            multiple
            collapse-tags
            placeholder="全部"
            size="mini"
            clearable
          >
            <el-option v-for="item in billtypeList" :label="item.name" :value="item.code" :key="item.code" />
          </el-select>
        </div>
        <div class="child" style="margin-left:12px">
          <el-button type="primary" size="mini" @click="handleSearch">查询</el-button>
          <el-button size="mini" @click="handleReset">重置</el-button>
        </div>
      </div>
    </div>

    <div class="table-wrap">
      <el-table
        :data="tableData"
        border
        @sort-change="sortChange"
        stripe
        style="width:100%;"
        size="small"
        show-summary
        :summary-method="getSummaries"
        v-loading="loading"
      >
        <el-table-column label="序号" align="center" width="60" type="index" fixed></el-table-column>
        <el-table-column
          prop="settleDate"
          label="支付时间"
          show-overflow-tooltip
          sortable="custom"
          align="center"
          min-width="160"
        />
        <el-table-column
          prop="settlePurchaseNo"
          label="支付单号"
          show-overflow-tooltip
          sortable="custom"
          align="center"
          min-width="180"
        />
        <el-table-column
          prop="settleCurr"
          label="付款金额"
          show-overflow-tooltip
          sortable="custom"
          align="center"
          min-width="120"
        >
          <template slot-scope="scope">{{ scope.row.settleCurr }}</template>
        </el-table-column>
        <el-table-column
          prop="settleDiscount"
          label="付款优惠"
          show-overflow-tooltip
          sortable="custom"
          align="center"
          min-width="120"
        >
          <template slot-scope="scope">{{ scope.row.settleDiscount }}</template>
        </el-table-column>
        <el-table-column
          prop="settlePrevFund"
          label="预付结算"
          show-overflow-tooltip
          sortable="custom"
          align="center"
          min-width="120"
        >
          <template slot-scope="scope">{{ scope.row.settlePrevFund }}</template>
        </el-table-column>
        <el-table-column
          prop="settleType"
          label="支付方式"
          show-overflow-tooltip
          sortable="custom"
          align="center"
          min-width="110"
        />
        <el-table-column
          prop="sourceBillType"
          label="来源类型"
          show-overflow-tooltip
          sortable="custom"
          align="center"
          min-width="110"
        />
        <el-table-column
          prop="sourceBillNo"
          label="来源单号"
          show-overflow-tooltip
          sortable="custom"
          align="center"
          min-width="180"
        />
        <!-- <el-table-column
          prop="checkNo"
          label="支票号"
          show-overflow-tooltip
          sortable="custom"
          align="center"
          min-width="120"
        /> -->
        <el-table-column
          prop="sourceBillDate"
          label="对账/业务时间"
          show-overflow-tooltip
          sortable="custom"
          align="center"
          min-width="150"
        />
        <el-table-column
          prop="createdAt"
          label="制单时间"
          show-overflow-tooltip
          sortable="custom"
          align="center"
          min-width="200"
        />
      </el-table>
    </div>

    <div style="margin-top:12px;text-align:right;">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        :page-size="searchParams.pageSize"
        :current-page.sync="searchParams.page"
        @size-change="
          s => {
            searchParams.pageSize = s;
            getList();
          }
        "
        @current-change="
          p => {
            searchParams.page = p;
            getList();
          }
        "
      />
    </div>
  </div>
</template>

<script>
import { settleList, billTypes } from "@/api/reconciliation";
import DateSelect from "@/components/DateSelect";
const dateRange = window.tool.getDateRangeByName("本月");
export default {
  name: "PaymentDetailTab",
  components: { DateSelect },
  data() {
    return {
      searchParams: {
        billNo: "",
        sourceBillTypes: [], //来源类型
        fromDate: dateRange[0],
        toDate: dateRange[1],
        sort: "",
        page: 1,
        pageSize: 10
      },
      tableData: [],
      total: 0,
      loading: false,
      billtypeList: [],
      totalInfo: {}
    };
  },
  mounted() {
    this.getList();
    this.getBillTypes();
  },
  methods: {
    //获取来源类型
    getBillTypes() {
      billTypes().then(res => {
        this.billtypeList = res || [];
      });
    },
    dateChange(dateObj) {
      this.searchParams.fromDate = dateObj.startDate;
      this.searchParams.toDate = dateObj.endDate;
    },
    // 合计行计算方法
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const prop = column.property;
        // 需要对哪些列进行合计
        const sumFields = ["settleCurr", "settleDiscount", "settlePrevFund"];
        if (sumFields.includes(prop)) {
          sums[index] = this.totalInfo[prop]; // 保留两位小数
        } else {
          sums[index] = "";
        }
      });
      return sums;
    },
    sortChange({ prop, order }) {
      if (order) {
        if (order.includes("desc")) {
          this.searchParams.sort = `${prop}-desc`;
        } else {
          this.searchParams.sort = `${prop}-asc`;
        }
      } else {
        this.searchParams.sort = "";
      }
      this.getList();
    },
    getList() {
      this.loading = true;
      settleList(this.searchParams)
        .then(res => {
          console.log("list", res);
          this.tableData = res.rows || [];
          this.total = res.totalSize;
          this.totalInfo = {
            settleCurr: res.amount,
            settleDiscount: res.discountAmount,
            settlePrevFund: res.prepayAmount
          };
        })
        .catch(err => {
          this.tableData = [];
          this.total = 0;
          this.$message.error(err.message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleSearch() {
      this.searchParams.page = 1;
      this.getList();
      // this.$message.success("查询支付明细 (静态演示)");
    },
    handleReset() {
      this.searchParams = {
        billNo: "",
        sourceBillTypes: [], //来源类型
        // fromDate: "",
        // toDate: "",
        sort: "",
        page: 1,
        pageSize: this.searchParams.pageSize
      };
      this.$refs.dateSelect.reset();
      this.$refs.dateSelect.confirm();
      this.getList();
    }
  }
};
</script>

<style lang="scss" scoped>
.search-box {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  box-sizing: border-box;
  background-color: rgba(249, 249, 249, 1);
  .left {
    display: flex;
    align-items: center;
    .child {
      display: flex;
      align-items: center;
      .label {
        font-size: 14px;
        color: #555555;
        min-width: 80px;
        text-align: right;
      }
    }
  }
}
.table-wrap {
  margin-top: 4px;
  overflow-x: auto;
}
.table-wrap .el-table {
  font-size: 13px;
}

// 合计行样式
.table-wrap ::v-deep .el-table__footer-wrapper {
  font-weight: bold;
  .el-table__footer td {
    background-color: #f5f7fa;
  }
}
</style>
